export const keySort = (key) => (a, b) => a[key].localeCompare(b[key]);

export default keySort;
